module.exports = __webpack_public_path__ + "static/media/sfl_4.91f3efd5.jpg";